import { render, staticRenderFns } from "./DecanatMainPanel.vue?vue&type=template&id=7fa5f51a&scoped=true&"
import script from "./DecanatMainPanel.vue?vue&type=script&lang=js&"
export * from "./DecanatMainPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa5f51a",
  null
  
)

export default component.exports